export { default } from './Window'
